<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-4">Mano paieškos</h3>

    <paieska-mano-search
      class="mt-1 mb-1"
      :loading="loadingList"
      @search="searchMano"
    />

    <paieska-mano-list
      v-if="showList"
      :paieskos="paieskos"
      :pagination="pagination"
      :loading="loadingList"
      @updatePagination="updatePagination"
      @updateList="updateList"
      @clickMoketi="clickMoketi"
    />

    <div class="disclaimer mt-4 mb-2" v-if="!pageloading">
      Paieškos rezultatas ir suformuoti išrašai saugomi
      {{ saugojimoLaikas }} k.d.
    </div>
  </v-container>
</template>

<script>
import PaieskaManoSearch from './PaieskaManoSearch'
import PaieskaManoList from './PaieskaManoList'

export default {
  name: 'PaieskaMano',
  components: { PaieskaManoSearch, PaieskaManoList },
  data: () => ({
    pageloading: true,
    loading: false,
    paieskos: [],
    showList: false,
    loadingList: true,
    saugojimoLaikas: null,
    israsoLaikas: null,
    searchData: {},
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0,
      sort: null,
      sortDesc: [],
      direction: 'asc',
    },
    paginationloading: false,
  }),
  computed: {
    //
  },
  created() {
    //
  },
  methods: {
    searchMano(searchData, silent = false) {
      this.searchData = searchData
      this.loadingList = !silent

      if (!silent) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: { ...searchData },
      }
      this.$axios
        .post(`paieska`, data)
        .then(res => {
          this.paieskos = res.data.paieskos
          this.saugojimoLaikas = res.data.saugojimo_laikas
          //this.israsoLaikas = res.data.israso_laikas
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
          this.loadingList = false
          this.paginationloading = false
          this.showList = true
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loadingList) {
        this.updateList()
      }
    },
    updateList() {
      this.searchMano(this.searchData, true)
    },
    clickMoketi(paieskaID, loading) {
      this.paieskos = this.paieskos.map(item => {
        if (item.pai_id === paieskaID) {
          item.loading = loading
        }
        return item
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
.disclaimer {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
  font-weight: 400;
}
</style>
